import { createSlice } from '@reduxjs/toolkit'

interface ConnectionState {
  available: boolean
};

const initialState: ConnectionState = {
  available: false
};

const connectionSlice = createSlice({
  name: 'connection',
  initialState,
  reducers: {
    setConnectionAvailability (state, action) {
      state.available = action.payload;
    }
  }
});

export const { setConnectionAvailability } = connectionSlice.actions;
export default connectionSlice.reducer;
